import { render } from "./BtnSidebar.vue?vue&type=template&id=2ee84f3b"
import script from "./BtnSidebar.vue?vue&type=script&lang=js"
export * from "./BtnSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__